export const menuPath = "<path d=\"M3 4.5 H13 M3 8 H13 M3 11.5 H13\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\"/>"
